
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Breadcrumb } from "@components/breadcrumb";
import { CompanyLogo } from "@components/company-logo";
import { Products } from "@components/products";
import { NextSeo } from "@components/seo";
import { ALU } from "@consts/aalu";
import type { ICompany } from "@type/company";
import type { IProduct } from "@type/products";
import { getAllAluByParent } from "@utils/get-products";
import type { GetStaticProps, NextPage } from "next/types";
import useTranslation from "next-translate/useTranslation";
interface ICompanyCard {
    company: ICompany;
    products: IProduct[];
}
const AluAluprof: NextPage<ICompanyCard> = ({ products, company }) => {
    const { t } = useTranslation("common");
    return (<>
      <NextSeo languageAlternates={[
            {
                href: "https://knsokna.pl/alu/doors/reynaers",
                hrefLang: "x-default",
            },
            { href: "https://knswindows.com/alu/doors/reynaers", hrefLang: "en" },
            { href: "https://knsokna.pl/alu/doors/reynaers", hrefLang: "pl" },
            { href: "https://knsfenster.de/alu/doors/reynaers", hrefLang: "de" },
            { href: "https://kns-okna.eu/alu/doors/reynaers", hrefLang: "cs" },
            { href: "https://knsfinestre.it/alu/doors/reynaers", hrefLang: "it" },
            { href: "https://knsfenetres.fr/alu/doors/reynaers", hrefLang: "fr" },
            { href: "https://knsokna.eu/alu/doors/reynaers", hrefLang: "hu" },
        ]}/>
      <div className="bg-white">
        <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
          <Breadcrumb />
          <h1 className="bg-gradient-to-r from-red to-orange p-1 font-bold text-3xl text-white">
            {company?.title}
          </h1>
          <CompanyLogo content={company?.content} logo="reynaers" title={company?.title}/>
          {t("menu.products")}:
          <br />
          <Products products={products} showId/>
          <hr />
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const { products, company } = await getAllAluByParent(ALU.DOORS.REYNAERS[LOCALE as keyof typeof ALU.DOORS.REYNAERS], LOCALE);
    return {
        props: {
            company,
            products,
        },
    };
};
export default AluAluprof;

    async function __Next_Translate__getStaticProps__1a19cd2bfd5__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/alu/doors/reynaers/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bfd5__ as getStaticProps }
  